/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Company_LabelInputs */

const en_contact_field_company_label = /** @type {(inputs: Contact_Field_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firm`)
};

/**
* | output |
* | --- |
* | "Firm" |
*
* @param {Contact_Field_Company_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_company_label = /** @type {((inputs?: Contact_Field_Company_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Company_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_company_label(inputs)
});